<script>
  import { mapState, mapStores } from 'pinia';
  import CommonUserMenu from '@/common/components/user/Menu.vue';
  import useAuthStore from '@/common/store/pinia/auth';
  import useTotpSettingsStore from '@/common/store/pinia/totpSettings';
  import useI18nStore from '@/common/store/pinia/i18n';

  export default {
    name: 'UserMenu',
    extends: CommonUserMenu,
    data() {
      return {
        logoutAfterTwoFactorReset: true
      };
    },
    mounted() {
      this.fetchTotpStatus();
    },
    computed: {
      ...mapStores(useAuthStore, useTotpSettingsStore),
      ...mapState(useI18nStore, ['isLanguageChangeAvailable']),
      isComputeConfigured() {
        return this.$store.getters['compute/isComputeConfigured'];
      },
      userMenuItems() {
        const isFederated = !!this.currentIdpId;
        return [
          ...(this.isLanguageChangeAvailable ? [{
            title: this.$t('Language'),
            right: true,
            icon: 'root-o',
            action: () => this.showLanguageDialog()
          }] : []),
          ...(isFederated ? [] : [{
            title: this.$t('Change password'),
            divided: true,
            action: () => this.showPasswordDialog()
          }]),
          {
            title: this.twoFactorMenuTitle,
            right: true,
            action: () => {
              if (this.totpStore.isTotpEnabled) {
                return this.showDisableTwoFactorAuthDialog();
              }
              return this.showTwoFactorAuthDialog();
            },
            class: 'two-factor-auth',
            disabled: this.totpLoading,
            visible: !isFederated,
          },
          {
            title: this.$t('API credentials'),
            action: () => this.$router.push({ name: 'apiTokens' }),
            visible: this.isComputeConfigured,
          },
          {
            title: this.$t('Log out'),
            class: 'log-out',
            divided: true,
            action: () => this.authStore.signOut()
          }
        ];
      }
    }
  };
</script>
